export function validateConvictionCandle(data) {
  const { candleDuration } = data;
  if (!candleDuration || candleDuration <= 0)
    return [false, 'You must enter a candle duration larger than 0'];
  if (!Number.isInteger(candleDuration))
    return [false, 'Candle Duration must be a whole number.'];
  return [true, ''];
}
